export const arealines = (duvalType) => {
  switch (duvalType) {
    case 1: {
      return [
        {
          from: { P1: 0, P2: 0.71 },
          to: { P1: 0.31, P2: 0.4 },
        },
        {
          from: { P1: 0.31, P2: 0.4 },
          to: { P1: 0.47, P2: 0.4 },
        },
        {
          from: { P1: 0.47, P2: 0.4 },
          to: { P1: 0.87, P2: 0 },
        },
        {
          from: { P1: 0, P2: 0.23 },
          to: { P1: 0.64, P2: 0.23 },
        },
        {
          from: { P1: 0, P2: 0.85 },
          to: { P1: 0.35, P2: 0.5 },
        },
        {
          from: { P1: 0.35, P2: 0.5 },
          to: { P1: 0.46, P2: 0.5 },
        },
        {
          from: { P1: 0.46, P2: 0.5 },
          to: { P1: 0.96, P2: 0 },
        },
        {
          from: { P1: 0.5, P2: 0.5 },
          to: { P1: 0.46, P2: 0.5 },
        },
        {
          from: { P1: 0.8, P2: 0.2 },
          to: { P1: 0.76, P2: 0.2 },
        },
        {
          from: { P1: 0.98, P2: 0.02 },
          to: { P1: 0.98, P2: 0 },
        },
      ];
    }
    case 4: {
      return [
        {
          from: { P1: 0.54, P2: 0 },
          to: { P1: 0.09, P2: 0.45 },
        },
        {
          from: { P1: 0.09, P2: 0 },
          to: { P1: 0.09, P2: 0.61 },
        },
        {
          from: { P1: 0, P2: 0.7 },
          to: { P1: 0.15, P2: 0.55 },
        },
        {
          from: { P1: 0.15, P2: 0.55 },
          to: { P1: 0.15, P2: 0.61 },
        },
        {
          from: { P1: 0.15, P2: 0.61 },
          to: { P1: 0.4, P2: 0.36 },
        },
        {
          from: { P1: 0.4, P2: 0.36 },
          to: { P1: 0.64, P2: 0.36 },
        },
        {
          from: { P1: 0.98, P2: 0.02 },
          to: { P1: 0.97, P2: 0.02 },
        },
        {
          from: { P1: 0.97, P2: 0.02 },
          to: { P1: 0.84, P2: 0.15 },
        },
        {
          from: { P1: 0.84, P2: 0.15 },
          to: { P1: 0.85, P2: 0.15 },
        },
      ];
    }
    case 5: {
      return [
        {
          from: { P1: 0, P2: 0.1 },
          to: { P1: 0.9, P2: 0.1 },
        },
        {
          from: { P1: 0.46, P2: 0 },
          to: { P1: 0.36, P2: 0.1 },
        },
        {
          from: { P1: 0.85, P2: 0 },
          to: { P1: 0.75, P2: 0.1 },
        },
        {
          from: { P1: 0.84, P2: 0.01 },
          to: { P1: 0.97, P2: 0.01 },
        },
        {
          from: { P1: 0.97, P2: 0.01 },
          to: { P1: 0.98, P2: 0 },
        },
        {
          from: { P1: 0, P2: 0.35 },
          to: { P1: 0.35, P2: 0.35 },
        },
        {
          from: { P1: 0.6, P2: 0.1 },
          to: { P1: 0, P2: 0.7 },
        },
        {
          from: { P1: 0, P2: 0.7 },
          to: { P1: 0.16, P2: 0.7 },
        },
        {
          from: { P1: 0.16, P2: 0.7 },
          to: { P1: 0.38, P2: 0.48 },
        },
        {
          from: { P1: 0.38, P2: 0.48 },
          to: { P1: 0.4, P2: 0.48 },
        },
        {
          from: { P1: 0.4, P2: 0.48 },
          to: { P1: 0.78, P2: 0.1 },
        },
        {
          from: { P1: 0.65, P2: 0.35 },
          to: { P1: 0.53, P2: 0.35 },
        },
      ];
    }
    default: {
      return [];
    }
  }
};

export const darkenHex = (color, amount) => {
  let R = Number.parseInt(color[1] + color[2], 16);
  let G = Number.parseInt(color[3] + color[4], 16);
  let B = Number.parseInt(color[5] + color[6], 16);

  R = R > amount ? R - amount : 0o0;
  G = G > amount ? G - amount : 0o0;
  B = B > amount ? B - amount : 0o0;

  const RHex = R > 16 ? R.toString(16) : `0${R.toString(16)}`;
  const BHex = B > 16 ? B.toString(16) : `0${B.toString(16)}`;
  const GHex = G > 16 ? G.toString(16) : `0${G.toString(16)}`;

  const darkenedColor = `#${RHex}${GHex}${BHex}`;
  return darkenedColor;
};

const getAreaColor = () => ({
  1: {
    PD: '#FFBFBF',
    T1: '#E8CACA',
    T2: '#BFDFBF',
    T3: '#BFBFFF',
    D1: '#DFBFDF',
    D2: '#FFE8BF',
    DT: '#BFDFDF',
  },
  4: {
    O: '#E8CACA',
    S: '#BFDFBF',
    PD: '#FFBFBF',
    C: '#BFBFFF',
    Unknown: '#DFBFDF',
  },
  5: {
    O: '#E8CACA',
    S: '#DFBFDF',
    PD: '#BFBFFF',
    O2: '#E8CACA',
    T2: '#BFDFBF',
    T3: '#FFBFBF',
    C: '#FFE8BF',
    Unknown: 'transparent',
  },
});

export const axislabels = (duvalType) => {
  switch (duvalType) {
    case 1: {
      return { left: 'CH4', right: 'C2H4', base: 'C2H2' };
    }
    case 4: {
      return { left: 'H2', right: 'CH4', base: 'C2H6' };
    }
    case 5: {
      return { left: 'CH4', right: 'C2H4', base: 'C2H6' };
    }
    default: {
      return { left: 'CH4', right: 'C2H4', base: 'C2H2' };
    }
  }
};
export const areas = (duvalType) => {
  switch (duvalType) {
    case 1: {
      return [
        {
          points: [
            {
              P1: 0,
              P2: 0,
            },
            {
              P1: 0,
              P2: 0.23,
            },
            {
              P1: 0.64,
              P2: 0.23,
            },
            {
              P1: 0.87,
              P2: 0,
            },
          ],
          name: 'D1 - Low energy discharge (sparking)',
          fill: getAreaColor()['1'].D1,
        },
        {
          points: [
            {
              P1: 0,
              P2: 0.23,
            },
            {
              P1: 0,
              P2: 0.71,
            },
            {
              P1: 0.31,
              P2: 0.4,
            },
            {
              P1: 0.47,
              P2: 0.4,
            },
            {
              P1: 0.64,
              P2: 0.23,
            },
          ],
          name: 'D2 - High energy discharge (arcing)',
          fill: getAreaColor()['1'].D2,
        },
        {
          points: [
            {
              P1: 0,
              P2: 0.71,
            },
            {
              P1: 0,
              P2: 0.85,
            },
            {
              P1: 0.35,
              P2: 0.5,
            },
            {
              P1: 0.46,
              P2: 0.5,
            },
            {
              P1: 0.96,
              P2: 0,
            },
            {
              P1: 0.87,
              P2: 0,
            },
            {
              P1: 0.47,
              P2: 0.4,
            },
            {
              P1: 0.31,
              P2: 0.4,
            },
          ],
          name: 'DT - Mixture of thermal and electrical faults',
          fill: getAreaColor()['1'].DT,
        },
        {
          points: [
            {
              P1: 0.76,
              P2: 0.2,
            },
            {
              P1: 0.8,
              P2: 0.2,
            },
            {
              P1: 0.98,
              P2: 0.02,
            },
            {
              P1: 0.98,
              P2: 0,
            },
            {
              P1: 0.96,
              P2: 0,
            },
          ],
          name: 'T1 - Thermal fault below 300 degrees celcius',
          fill: getAreaColor()['1'].T1,
        },
        {
          points: [
            {
              P1: 0.46,
              P2: 0.5,
            },
            {
              P1: 0.5,
              P2: 0.5,
            },
            {
              P1: 0.8,
              P2: 0.2,
            },
            {
              P1: 0.76,
              P2: 0.2,
            },
          ],
          name: 'T2 - Thermal fault between 300 and 700 degrees celcius',
          fill: getAreaColor()['1'].T2,
        },
        {
          points: [
            {
              P1: 0,
              P2: 0.85,
            },
            {
              P1: 0,
              P2: 1,
            },
            {
              P1: 0.5,
              P2: 0.5,
            },
            {
              P1: 0.35,
              P2: 0.5,
            },
          ],
          name: 'T3 - Thermal fault above 700 degrees celcius',
          fill: getAreaColor()['1'].T3,
        },
        {
          points: [
            {
              P1: 0.98,
              P2: 0.02,
            },
            {
              P1: 1,
              P2: 0,
            },
            {
              P1: 0.98,
              P2: 0,
            },
          ],
          name: 'PD - Partial discharge',
          fill: getAreaColor()['1'].PD,
        },
      ];
    }
    case 4: {
      return [
        {
          points: [
            {
              P1: 0.09,
              P2: 0,
            },
            {
              P1: 0.09,
              P2: 0.61,
            },
            {
              P1: 0,
              P2: 0.7,
            },
            {
              P1: 0,
              P2: 0,
            },
          ],
          name: 'O - Overheating',
          fill: getAreaColor()['4'].O,
        },
        {
          points: [
            {
              P1: 0.54,
              P2: 0,
            },
            {
              P1: 1,
              P2: 0,
            },
            {
              P1: 0.98,
              P2: 0.02,
            },
            {
              P1: 0.97,
              P2: 0.02,
            },
            {
              P1: 0.84,
              P2: 0.15,
            },
            {
              P1: 0.85,
              P2: 0.15,
            },
            {
              P1: 0.64,
              P2: 0.36,
            },
            {
              P1: 0.4,
              P2: 0.36,
            },
            {
              P1: 0.15,
              P2: 0.61,
            },
            {
              P1: 0.15,
              P2: 0.55,
            },
            {
              P1: 0.09,
              P2: 0.61,
            },
            {
              P1: 0.09,
              P2: 0.45,
            },
          ],
          name: 'S - Stray gassing',
          fill: getAreaColor()['4'].S,
        },
        {
          points: [
            {
              P1: 0.98,
              P2: 0.02,
            },
            {
              P1: 0.97,
              P2: 0.02,
            },
            {
              P1: 0.84,
              P2: 0.15,
            },
            {
              P1: 0.85,
              P2: 0.15,
            },
          ],
          name: 'PD - Partial Discharge',
          fill: getAreaColor()['4'].PD,
        },
        {
          points: [
            {
              P1: 0.64,
              P2: 0.36,
            },
            {
              P1: 0.4,
              P2: 0.36,
            },
            {
              P1: 0.15,
              P2: 0.61,
            },
            {
              P1: 0.15,
              P2: 0.55,
            },
            {
              P1: 0,
              P2: 0.7,
            },
            {
              P1: 0,
              P2: 1,
            },
          ],
          name: 'C - Carbonisation',
          fill: getAreaColor()['4'].C,
        },
        {
          points: [
            {
              P1: 0.54,
              P2: 0,
            },
            {
              P1: 0.09,
              P2: 0.45,
            },
            {
              P1: 0.09,
              P2: 0,
            },
          ],
          name: 'NA - Unknown',
          fill: getAreaColor()['4'].Unknown,
        },
      ];
    }
    case 5: {
      return [
        {
          points: [
            {
              P1: 0,
              P2: 0,
            },
            {
              P1: 0.46,
              P2: 0,
            },
            {
              P1: 0.36,
              P2: 0.1,
            },
            {
              P1: 0,
              P2: 0.1,
            },
          ],
          name: 'O - Overheating',
          fill: getAreaColor()['5'].O,
        },
        {
          points: [
            {
              P1: 0.46,
              P2: 0,
            },
            {
              P1: 0.36,
              P2: 0.1,
            },
            {
              P1: 0.75,
              P2: 0.1,
            },
            {
              P1: 0.85,
              P2: 0,
            },
          ],
          name: 'S - Stray Gassing',
          fill: getAreaColor()['5'].S,
        },
        {
          points: [
            {
              P1: 0.85,
              P2: 0,
            },
            {
              P1: 0.84,
              P2: 0.01,
            },
            {
              P1: 0.97,
              P2: 0.01,
            },
            {
              P1: 0.98,
              P2: 0,
            },
          ],
          name: 'PD - Partial Discharge',
          fill: getAreaColor()['5'].PD,
        },
        {
          points: [
            {
              P1: 0.84,
              P2: 0.01,
            },
            {
              P1: 0.75,
              P2: 0.1,
            },
            {
              P1: 0.9,
              P2: 0.1,
            },
            {
              P1: 1,
              P2: 0,
            },
            {
              P1: 0.98,
              P2: 0,
            },
            {
              P1: 0.97,
              P2: 0.01,
            },
            {
              P1: 0.84,
              P2: 0.01,
            },
            {
              P1: 0.85,
              P2: 0,
            },
          ],
          name: 'O2 - Overheating 2',
          fill: getAreaColor()['5'].O2,
        },
        {
          points: [
            {
              P1: 0.9,
              P2: 0.1,
            },
            {
              P1: 0.78,
              P2: 0.1,
            },
            {
              P1: 0.53,
              P2: 0.35,
            },
            {
              P1: 0.65,
              P2: 0.35,
            },
          ],
          name: 'T2 - Thermal Fault',
          fill: getAreaColor()['5'].T2,
        },
        {
          points: [
            {
              P1: 0.65,
              P2: 0.35,
            },
            {
              P1: 0.53,
              P2: 0.35,
            },
            {
              P1: 0.4,
              P2: 0.48,
            },
            {
              P1: 0.38,
              P2: 0.48,
            },
            {
              P1: 0.16,
              P2: 0.7,
            },
            {
              P1: 0,
              P2: 0.7,
            },
            {
              P1: 0.35,
              P2: 0.35,
            },
            {
              P1: 0,
              P2: 0.35,
            },
            {
              P1: 0,
              P2: 1,
            },
          ],
          name: 'T3 - Thermal Fault',
          fill: getAreaColor()['5'].T3,
        },
        {
          points: [
            {
              P1: 0.53,
              P2: 0.35,
            },
            {
              P1: 0.4,
              P2: 0.48,
            },
            {
              P1: 0.38,
              P2: 0.48,
            },
            {
              P1: 0.16,
              P2: 0.7,
            },
            {
              P1: 0,
              P2: 0.7,
            },
            {
              P1: 0.6,
              P2: 0.1,
            },
            {
              P1: 0.78,
              P2: 0.1,
            },
          ],
          name: 'C - Carbonisation',
          fill: getAreaColor()['5'].C,
        },
        {
          points: [
            {
              P1: 0,
              P2: 0.35,
            },
            {
              P1: 0.35,
              P2: 0.35,
            },
            {
              P1: 0.6,
              P2: 0.1,
            },
            {
              P1: 0,
              P2: 0.1,
            },
          ],
          name: 'Unknown',
          fill: getAreaColor()['5'].Unknown,
        },
      ];
    }
    default: {
      return [];
    }
  }
};
